import React from "react";
import { Link } from "react-router-dom";
import { companiesData } from "../data/companiesData";

const HeroSlider = () => {
  return (
    

    <section className="hero-section">
       <div className="hero-heading">Transparency In <br/>
            Corporate Reporting <br/>
            (TRAC)</div>

              <div className="hero-Para">
                ASSESSING PAKISTAN’S TOP 69 PUBLIC LIMITED COMPANIES
              </div>


            

  <div className="leaderboard-card">

    <h2 className="leaderboard-title">Overall Results</h2>
    

    <div className="leaderboard-table-wrapper">
      <table className="leaderboard-table">
        <thead>
          <tr>
            {/* <th>Id</th> */}
            <th>Rank</th>
            <th>Company</th>
            <th>Score</th>
          </tr>
        </thead>

        <tbody>
          {companiesData.map((c) => (
            <tr key={c.id}>
              {/* <td className="center">{c.id}</td> */}
              <td className="center">{c.rank}</td>
              <td>
                <Link
                  to={`/company/${c.id}`}
                  className="leaderboard-company-link"
                >
                  {c.name}
                </Link>
              </td>
              <td className="center">
                {c.AverageScoresofEachCompany}%
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="leaderboard-footer">
      Assessment Procedure:
      <select>
        <option>2024</option>
        <option disabled>2025</option>
      </select>
    </div>

  </div>
</section>
  );
};

export default HeroSlider;